import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import CmpVideoLink from "./videoLink.cmp";
import "./videoList.cmp.scss";

const CmpVideoList = ({ videoList, layout = "grid" }) => {
	const cssClass = layout === "sidebar" ? "col-12 compact" : undefined;
	const currVideoId = useSelector(state => state.video.currVideo?.videoId);
	const scrollRef = useRef();

	// Mantiene visibile il video in riproduzione, scorrendo solo la lista
	useEffect(() => {
		const box = scrollRef.current;
		const item = box?.querySelector(".cmp-video-link.current");
		if (!box || !item || box.scrollHeight <= box.clientHeight) return;

		const boxRect = box.getBoundingClientRect();
		const itemRect = item.getBoundingClientRect();
		if (itemRect.top < boxRect.top || itemRect.bottom > boxRect.bottom) {
			box.scrollTo({ top: box.scrollTop + itemRect.top - boxRect.top - 8, behavior: "smooth" });
		}
	}, [currVideoId]);

	const items = videoList.map(v => <CmpVideoLink key = {v.videoId} video = {v} cssClass = {cssClass}/>);

	if (layout !== "sidebar") {
		return <div className = "cmp-video-list grid">
			<div className = "row">{items}</div>
		</div>;
	}

	return <div className = "cmp-video-list sidebar">
		<div className = "list-header">
			<span>Video del corso</span>
			<span className = "count">{videoList.length}</span>
		</div>
		<div className = "list-scroll" ref = {scrollRef}>
			<div className = "row">{items}</div>
		</div>
	</div>;
}

export default CmpVideoList;
